import styled from 'styled-components'
import React from 'react'
import {useTownhallTemplate} from 'Event/template/Townhall'
import Grid from '@material-ui/core/Grid'
import {rgba} from 'lib/color'
import Configurable from 'organization/Event/Configurable'
import RightPanelConfig from 'Event/template/Townhall/Login/RightPanel/RightPanelConfig'

export default function RightPanel(props: {
  children: React.ReactElement | React.ReactElement[]
}) {
  const {login} = useTownhallTemplate()

  const backgroundColor = rgba(
    login.rightPanel.backgroundColor,
    login.rightPanel.backgroundOpacity / 100,
  )

  return (
    <RightGrid item xs={12} md={6} backgroundColor={backgroundColor}>
      <Configurable aria-label="login right panel config">
        <RightPanelConfig />
        <Container>{props.children}</Container>
      </Configurable>
    </RightGrid>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  width: 100%;
`

const RightGrid = styled((props) => {
  const {backgroundColor: _, ...otherProps} = props
  return <Grid {...otherProps} />
})<{backgroundColor?: string}>`
  display: flex;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : '#ffffff'};
  padding-left: ${(props) => props.theme.spacing[10]};
  padding-right: ${(props) => props.theme.spacing[10]};
`
